"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.search.failed': 'Failed to search DB logs. Please try again.',
};
